export const changeConfig = config => ({
    type: 'CHANGE_CONFIG',
    payload: config
});

export const setBackURI = (uri) => ({
    type: 'SET_BACK_URI',
    payload: uri
});
